import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule, MatSelectModule } from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DataTablesModule } from 'angular-datatables';
import { AngularSplitModule } from 'angular-split';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgxBootstrapSliderModule } from 'ngx-bootstrap-slider';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { UtilsModule } from 'src/app/utils/utils.module';

import { SideBarModule } from '../side-bar/side-bar.module';
import { BottombarDataModuleModule } from './bottombar-data-module/bottombar-data-module.module';
import { BottombarDataComponent } from './bottombar-data/bottombar-data.component';
import { BottombarMenuComponent } from './bottombar-menu/bottombar-menu.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ConstantsModule } from './constants/constants.module';
import { GisMapFloodForecastComponent } from './gis-map-flood-forecast/gis-map-flood-forecast.component';
import { GisMapWidgetComponent } from './gis-map-widget/gis-map-widget.component';
import { GisMapComponent } from './gis-map/gis-map.component';
import { GisMiniMapComponent } from './gis-mini-map/gis-mini-map.component';
import { GismistoggleComponent } from './gismistoggle/gismistoggle.component';
import { MapControlComponent } from './map-control/map-control.component';
import { MapsearchComponent } from './mapsearch/mapsearch.component';
import { PlayProgressBarComponent } from './play-progress-bar/play-progress-bar.component';
import { RightsidePanelComponent } from './rightside-panel/rightside-panel.component';
import { ShareModalComponent } from './share-modal/share-modal/share-modal.component';
import { SharedComponent } from './shared.component';
import { SpinnerModule } from './spinner/spinner.module';
import { SpinnerComponent } from './spinner/spinner.component';
import { StockChartModule } from './stock-chart-module/stock-chart/stock-chart.module';
import { TableModule } from './table/table.module';
import { ThumbnailComponent } from './thumbnail/thumbnail.component';
import { TimeMenuComponent } from './time-menu/time-menu.component';
import { UtilsSharedModule } from './utils/utils/utils.module';
import { GisMapWidgetFfComponent } from './gis-map-widget-ff/gis-map-widget-ff.component';
import { AuthModule } from '../authentication/auth.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
// import { HttpLoaderFactory } from '../landing-page/header/header.module';
import { ApplicationTitleComponent } from './application-title/application-title.component';
import { AccuracyPopupDataTableComponent } from './accuracy-popup-data-table/accuracy-popup-data-table.component';
import { PlayAnimationScalebarComponent } from './play-animation-scalebar/play-animation-scalebar.component';
import { PlayBarNgxComponent } from './play-bar-ngx/play-bar-ngx.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { GisMapAlertComponent } from './gis-map-alert/gis-map-alert.component';
import { BottomBarModule } from './bottom-bar/bottom-bar.module';
import { AlertPlayProgressBarComponent } from './alert-play-progress-bar/alert-play-progress-bar.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { GisDimsMapComponent } from './gis-dims-map/gis-dims-map.component';
import { HeatwaveInfoboxComponent } from '../side-bar/heat-watch/heatwave/heatwave-infobox/heatwave-infobox.component';
import { TimeMenuToggleComponent } from './time-menu-toggle/time-menu-toggle.component';
import { ImageSliderComponent } from './image-slider/image-slider.component';
import { DisasterPopupTableComponent } from '../side-bar/disaster-monitoring/monitor-dashboard/disaster-popup-table/disaster-popup-table.component';
import { NewPlayBarComponent } from './new-play-bar/new-play-bar.component';
import { ObjectKeysPipe, KeyvaluePipe, KeyvalueOrderPipe } from './pipes/object-keys.pipe';
import { NgxPlaybarNewComponent } from './ngx-playbar-new/ngx-playbar-new.component';
import { GisNhipMapComponent } from './gis-nhip-map/gis-nhip-map.component';
import { NhipHomeInfoboxComponent } from '../side-bar/nhip-dashboard/nhip-home/nhip-home-infobox/nhip-home-infobox.component';
import { NhipHomeNavbarComponent } from '../side-bar/nhip-dashboard/nhip-home/nhip-home-navbar/nhip-home-navbar.component';
@NgModule({
  declarations: [
    RightsidePanelComponent,
    BottombarMenuComponent,
    BottombarDataComponent,
    GisMapComponent,
    MapControlComponent,
    PlayProgressBarComponent,
    RightsidePanelComponent,
    ThumbnailComponent,
    TimeMenuComponent,
    SharedComponent,
    BreadcrumbComponent,
    MapsearchComponent,
    GisMiniMapComponent,
    GismistoggleComponent,
    ShareModalComponent,
    GisMapFloodForecastComponent,
    GisMapWidgetComponent,
    GisMapWidgetFfComponent,
    ApplicationTitleComponent,
    AccuracyPopupDataTableComponent,
    PlayAnimationScalebarComponent,
    PlayBarNgxComponent,
    GisMapAlertComponent,
    AlertPlayProgressBarComponent,
    GisDimsMapComponent,
    HeatwaveInfoboxComponent,
    TimeMenuToggleComponent,
    ImageSliderComponent,
    DisasterPopupTableComponent,
    NewPlayBarComponent,
    ObjectKeysPipe,
    KeyvaluePipe,
    KeyvalueOrderPipe,
    NgxPlaybarNewComponent,
    GisNhipMapComponent,
    NhipHomeInfoboxComponent,
    NhipHomeNavbarComponent
  ],
  entryComponents: [
    ShareModalComponent,
    AccuracyPopupDataTableComponent,
    GisMapAlertComponent,
    GisMiniMapComponent,
    PlayProgressBarComponent,
    AlertPlayProgressBarComponent,
    HeatwaveInfoboxComponent,
    DisasterPopupTableComponent,
    NhipHomeInfoboxComponent,
    NhipHomeNavbarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    UtilsModule,
    NgSelectModule,
    AngularSplitModule,
    MatTableModule,
    NgxBootstrapSliderModule,
    DataTablesModule,
    NgxDatatableModule,
    SideBarModule,
    ConstantsModule,
    UtilsSharedModule,
    TableModule,
    HighchartsChartModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatFormFieldModule,
    NgxMatSelectSearchModule,
    StockChartModule,
    BottombarDataModuleModule,
    NgbModule,
    SpinnerModule,
    AuthModule,
    NgxSliderModule,
    BottomBarModule,
    NgxUiLoaderModule.forRoot({
      fgsType: 'ball-spin',
      overlayColor: 'rgba(255,255,255,0.5)',
      fgsSize: 40,
      pbThickness: 2,
      hasProgressBar: false,
      pbColor: '#0000FF'
    }),
    DragDropModule
    // TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient]
    //   }
    // })
  ],
  exports: [
    RightsidePanelComponent,
    BottombarMenuComponent,
    BottombarDataComponent,
    GisMapComponent,
    MapControlComponent,
    PlayProgressBarComponent,
    RightsidePanelComponent,
    ThumbnailComponent,
    TimeMenuComponent,
    SharedComponent,
    ConstantsModule,
    UtilsSharedModule,
    BreadcrumbComponent,
    SpinnerModule,
    TableModule,
    StockChartModule,
    GisMapFloodForecastComponent,
    GisMapWidgetComponent,
    GisMapWidgetFfComponent,
    ApplicationTitleComponent,
    AccuracyPopupDataTableComponent,
    PlayAnimationScalebarComponent,
    PlayBarNgxComponent,
    MapsearchComponent,
    GisMapAlertComponent,
    GisMiniMapComponent,
    BottomBarModule,
    AlertPlayProgressBarComponent,
    DragDropModule,
    GisDimsMapComponent,
    TimeMenuToggleComponent,
    ImageSliderComponent,
    ObjectKeysPipe,
    KeyvaluePipe,
    KeyvalueOrderPipe,
    GisNhipMapComponent
  ],
  providers: [DatePipe]
})
export class SharedModule { }
